"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelectListItem = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var util_1 = require("@gooddata/util");
var Bubble_1 = require("../Bubble");
var BUBBLE_OFFSET_X = 16;
/**
 * @internal
 */
var SingleSelectListItem = /** @class */ (function (_super) {
    tslib_1.__extends(SingleSelectListItem, _super);
    function SingleSelectListItem(props) {
        var _this = _super.call(this, props) || this;
        _this.titleRef = react_1.createRef();
        _this.getClassNames = function () {
            var _a = _this.props, title = _a.title, isSelected = _a.isSelected, className = _a.className;
            var generatedSeleniumClass = "s-" + util_1.stringUtils.simplifyText(title);
            return classnames_1.default("gd-list-item", className, generatedSeleniumClass, { "is-selected": isSelected });
        };
        _this.renderTitle = function () {
            var title = _this.props.title;
            var titleElement = react_1.default.createElement("span", { ref: _this.titleRef }, title);
            if (_this.state.isOverflowed) {
                return (react_1.default.createElement(Bubble_1.BubbleHoverTrigger, null,
                    titleElement,
                    react_1.default.createElement(Bubble_1.Bubble, { className: "bubble-primary", alignPoints: [{ align: "cr cl" }, { align: "cl cr" }], arrowOffsets: {
                            "cr cl": [BUBBLE_OFFSET_X, 0],
                            "cl cr": [-BUBBLE_OFFSET_X, 0],
                        } }, title)));
            }
            return titleElement;
        };
        _this.renderIcon = function (icon) {
            if (icon) {
                var iconClasses = classnames_1.default("gd-list-icon", icon);
                return react_1.default.createElement("span", { className: iconClasses });
            }
            return null;
        };
        _this.renderSeparatorItem = function () {
            return react_1.default.createElement("div", { className: "gd-list-item gd-list-item-separator s-list-separator" });
        };
        _this.renderHeaderItem = function () {
            return react_1.default.createElement("div", { className: "gd-list-item gd-list-item-header s-list-header" }, _this.props.title);
        };
        _this.renderInfo = function () {
            if (!_this.props.info) {
                return null;
            }
            return (react_1.default.createElement("div", { className: "gd-list-item-bubble s-list-item-info" },
                react_1.default.createElement(Bubble_1.BubbleHoverTrigger, { tagName: "div", showDelay: 200, hideDelay: 0 },
                    react_1.default.createElement("div", { className: "inlineBubbleHelp" }),
                    react_1.default.createElement(Bubble_1.Bubble, { className: "bubble-primary", alignPoints: [{ align: "cr cl" }], arrowOffsets: { "cr cl": [15, 0] } }, _this.props.info))));
        };
        _this.state = { isOverflowed: false };
        return _this;
    }
    SingleSelectListItem.prototype.componentDidMount = function () {
        this.checkOverflow();
    };
    SingleSelectListItem.prototype.componentDidUpdate = function () {
        this.checkOverflow();
    };
    SingleSelectListItem.prototype.checkOverflow = function () {
        if (this.titleRef.current) {
            // Checks if ellipsis has been applied on title span
            var isOverflowed = this.titleRef.current.offsetWidth < this.titleRef.current.scrollWidth;
            if (isOverflowed !== this.state.isOverflowed) {
                // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                    isOverflowed: isOverflowed,
                });
            }
        }
    };
    SingleSelectListItem.prototype.render = function () {
        var _a = this.props, icon = _a.icon, onClick = _a.onClick, onMouseOver = _a.onMouseOver, onMouseOut = _a.onMouseOut, type = _a.type;
        if (type === "separator") {
            return this.renderSeparatorItem();
        }
        if (type === "header") {
            return this.renderHeaderItem();
        }
        return (react_1.default.createElement("div", { className: this.getClassNames(), onClick: onClick, onMouseOver: onMouseOver, onMouseOut: onMouseOut },
            this.renderIcon(icon),
            this.renderTitle(),
            this.renderInfo()));
    };
    return SingleSelectListItem;
}(react_1.Component));
exports.SingleSelectListItem = SingleSelectListItem;
//# sourceMappingURL=ListItem.js.map